import { closeModal, useModalStore } from "./store";

import { Box } from "@/components/atoms/box";
import { Modal } from "@/components/atoms/modal/modal";

export function ModalContainer() {
  const { isOpen, children, options } = useModalStore();

  return (
    <Modal open={isOpen} onClose={closeModal} {...options}>
      {options?.noBox ? (
        children
      ) : (
        <Box px={"l5"} py={"l5"} radius={"lg"}>
          {children}
        </Box>
      )}
    </Modal>
  );
}
